import { FunctionComponent, useEffect, useState } from 'react';
import TextInputField from '../../Components/TextInput/TextInputField';
import { FormikProps, useFormik } from 'formik';
import Select from '../../Components/Select/Select';
import { Checkbox, FormControlLabel } from '@mui/material';
import { IPackageCard } from './IPacakageManagement';
import { AutocompleteOption } from '../../Components/Select/ISelectProps';
import * as Yup from 'yup';

import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';

import { clearUpdateableData, clearUpdatePackageState, updatePackage } from '../../Redux/Slicers/PackageManagement/UpdatePackageManagementSlicer';
import { addPackage, clearAddPackageState } from '../../Redux/Slicers/PackageManagement/AddPackageManagementSlicer';

interface MasterFormProps {
  masterForm: (data: FormikProps<any>) => void;
}

const MasterForm: FunctionComponent<MasterFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const { updateableDate } = useAppSelector((state) => state.UpdatePackage);
  const [showWorkingTime, setShowWorkingTime] = useState(false);
  console.log(updateableDate);
  const pathParts = window.location.pathname.split("/");
  const locationId = pathParts[pathParts.length - 1]; // last part of the path

  const masterFrom = useFormik<IPackageCard>({
    initialValues,
    validationSchema: Yup.object().shape({
      package_name: Yup.string().required('Please enter Name'),
      package_price: Yup.string().required('Please enter price'),
      package_days: Yup.number().required('Please enter days'),
      package_description: Yup.string().required('Please enter description'),
      package_type: Yup.string().required('Please select type'),
    }),
    onSubmit: (value) => {
      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        dispatch(updatePackage({ ...value, id: updateableDate._id }));
      } else {
        dispatch(addPackage({ ...value, location_id: locationId }));
      }
    },
  });

  useEffect(() => {
    props.masterForm(masterFrom);
    if (updateableDate) {
      masterFrom.setFieldValue("package_name", updateableDate.package_name);
      masterFrom.setFieldValue("package_price", updateableDate.package_price);
      masterFrom.setFieldValue("package_days", updateableDate.package_days);
      masterFrom.setFieldValue(
        "package_description",
        updateableDate.package_description
      );
      masterFrom.setFieldValue("package_type", updateableDate.package_type);
      if (updateableDate.working_hours) {
        masterFrom.setFieldValue(
          "working_hours",
          updateableDate.working_hours
        );
      }
    }

    const hasWorkingTime = Boolean(
      updateableDate?.working_hours &&
        Object.values(updateableDate.working_hours).some(
          (time: any) => Boolean(time?.open || time?.start || time?.end)
        )
    );
    setShowWorkingTime(hasWorkingTime);

    return () => {
      dispatch(clearAddPackageState());
      dispatch(clearUpdatePackageState());
      dispatch(clearUpdateableData());

      masterFrom.resetForm();
    };
  }, [updateableDate]);

  const renderWorkingHoursFields = (
    day: keyof IPackageCard["working_hours"]
  ) => {
    const workingHours = masterFrom.values.working_hours;
    const dayKey = day as string;
    const dayHours = workingHours[day];

    return (
      <>
        <div style={{ display: "flex", columnGap: "10px" }}>
          <Select
            sx={{ width: "50%" }}
            id={`working_hours.${dayKey}.open`}
            name={`working_hours.${dayKey}.open`}
            label={`${dayKey.charAt(0).toUpperCase() + dayKey.slice(1)} Status`}
            value={dayHours.open ? "Active" : "Deactive"}
            options={["Active", "Deactive"]}
            onChange={(_, value) => {
              masterFrom.setFieldValue(
                `working_hours.${dayKey}.open`,
                value === "Active"
              );
            }}
            onBlur={masterFrom.handleBlur}
            placeholder="-select-"
          />
          {dayHours.open && (
            <>
              <TextInputField
                sx={{ width: "25%" }}
                id={`working_hours.${dayKey}.start`}
                name={`working_hours.${dayKey}.start`}
                label={`${dayKey.charAt(0).toUpperCase() + dayKey.slice(1)} Start Time`}
                value={dayHours.start}
                onChange={masterFrom.handleChange}
                onBlur={masterFrom.handleBlur}
                placeholder="00:00"
              />
              <TextInputField
                sx={{ width: "25%" }}
                id={`working_hours.${dayKey}.end`}
                name={`working_hours.${dayKey}.end`}
                label={`${dayKey.charAt(0).toUpperCase() + dayKey.slice(1)} End Time`}
                value={dayHours.end}
                onChange={masterFrom.handleChange}
                onBlur={masterFrom.handleBlur}
                placeholder="00:00"
              />
            </>
          )}
        </div>
      </>
    );
  };

  return (
    <form
      className="master_form"
      onSubmit={masterFrom.handleSubmit}
      onReset={masterFrom.handleReset}
      autoComplete="off">
      <TextInputField
        id="package_name"
        name="package_name"
        label="Name"
        value={masterFrom.values.package_name}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.package_name && masterFrom.errors.package_name
        }
        error={
          masterFrom.touched.package_name && Boolean(masterFrom.errors.package_name)
        }
      />

         <TextInputField
        id="package_price"
        name="package_price"
        label="Price"
        value={masterFrom.values.package_price}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.package_price && masterFrom.errors.package_price
        }
        error={
          masterFrom.touched.package_price && Boolean(masterFrom.errors.package_price)
        }
      />

            <TextInputField
        id="package_days"
        name="package_days"
        label="Days"
        value={masterFrom.values.package_days}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.package_days && masterFrom.errors.package_days
        }
        error={
          masterFrom.touched.package_days && Boolean(masterFrom.errors.package_days)
        }
      />

     

      <Select
        id="package_type"
        name="package_type"
        label="Type"
        value={masterFrom.values.package_type || null}

        // value={
        //   masterFrom.values.package_type === null ||
        //   masterFrom.values.package_type === undefined
        //     ? null
        //     : masterFrom.values.package_type
        //     ? 'Monthly'
        //     : 'Days'
        // }
        options={['Monthly', 'Days']}
        onChange={(_, value) => {
          masterFrom.setFieldValue("package_type", value || null);
        }}
        // onChange={(_, value) => {
        //   masterFrom.setFieldValue(
        //     'package_type',
        //     value === null ? null : value === 'Monthly'
        //   );
        // }}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.package_type && masterFrom.errors.package_type}
        error={masterFrom.touched.package_type && Boolean(masterFrom.errors.package_type)}
        placeholder="-select-"
      />

      <TextInputField
        id="package_description"
        name="package_description"
        label="Description"
        value={masterFrom.values.package_description}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.package_description && masterFrom.errors.package_description
        }
        error={
          masterFrom.touched.package_description && Boolean(masterFrom.errors.package_description)
        }
      />

      <div style={{ width: "100%", marginTop: 16 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showWorkingTime}
              onChange={(event) => setShowWorkingTime(event.target.checked)}
            />
          }
          label="Working Time"
        />
        {showWorkingTime &&
          Object.keys(masterFrom.values.working_hours).map((day) => (
            <div style={{ width: "100%", marginTop: 8 }} key={day}>
              {renderWorkingHoursFields(day as keyof IPackageCard["working_hours"])}
            </div>
          ))}
      </div>

      <button
        type="submit"
        style={{ display: 'none' }}
      />
    </form>
  );
};

export default MasterForm;

const initialValues = {
  package_name: "",
  package_price: "",
  package_days: 0,
  package_description: "",
  package_type: "",
  location_id: "",
  working_hours: {
    sun: { open: false, start: "", end: "" },
    mon: { open: false, start: "", end: "" },
    tues: { open: false, start: "", end: "" },
    wed: { open: false, start: "", end: "" },
    thurs: { open: false, start: "", end: "" },
    fri: { open: false, start: "", end: "" },
    sat: { open: false, start: "", end: "" },
  },
} as IPackageCard;
